import { getTextByValue } from "../../Utilities/Types/listUtilities";
import { CHECKIN_TITLES_LIST } from "./checkInConstants";

export const getCheckInTitleTextByValue = (value: string | number = "") => getTextByValue(CHECKIN_TITLES_LIST, value);